import { DeliveryConfiguration } from '../../../../@types/model/deliveryConfiguration';
import { DeliveryRequestItem } from '../../../../@types/model/deliveryRequest';

export type FusionDeliveryRequestItem = {
  product: string;
  quantity: number;
};

const generateSlotsOccupiedGrouped = (
  deliveryRequestItems: DeliveryRequestItem[],
  deliveryConfiguration: DeliveryConfiguration,
  newDeliveryRequestItem: DeliveryRequestItem | null
): FusionDeliveryRequestItem[] => {
  // Agrupamos todos los productos del carrito en grupos para ver si pueden entrar en los cajones.
  let products: FusionDeliveryRequestItem[] = [];
  deliveryRequestItems.forEach((sri: DeliveryRequestItem) => {
    let search = false;
    products.forEach((p, index) => {
      if (p.product === sri.productType) {
        search = true;
        products[index].quantity = products[index].quantity + sri.quantity;
      }
    });
    if (!search) {
      products.push({
        product: sri?.productType + '',
        quantity: sri.quantity
      });
    }
  });
  if (newDeliveryRequestItem) {
    let search = false;
    products.forEach((p, index) => {
      if (p.product === newDeliveryRequestItem.productType) {
        search = true;
        products[index].quantity = products[index].quantity + newDeliveryRequestItem.quantity;
      }
    });
    if (!search) {
      products.push({
        product: newDeliveryRequestItem?.productType + '',
        quantity: newDeliveryRequestItem.quantity
      });
    }
  }
  let slots: FusionDeliveryRequestItem[] = [];
  products.forEach((p) => {
    if (p.quantity < deliveryConfiguration.configuration.slot_amount) {
      slots.push(p);
    } else {
      let quantity = p.quantity;
      while (quantity > 0) {
        if (quantity < deliveryConfiguration.configuration.slot_amount) {
          slots.push({
            product: p.product,
            quantity: quantity
          });
        } else {
          slots.push({
            product: p.product,
            quantity: deliveryConfiguration.configuration.slot_amount
          });
        }
        quantity -= deliveryConfiguration.configuration.slot_amount;
      }
    }
  });
  return slots;
};

export default generateSlotsOccupiedGrouped;
